<template lang="pug">
  v-row
    v-col(cols="12")
      h1 Преподаватели
    v-col
      server-data(
        :method="$api.system.getTeacherLevels"
        v-slot="{ serverData }"
      )
        v-crud-datatable.sdo-card.pa-4(
          :headers="headers"
          :method-create="$api.teachers.create"
          :method-list="({ params }) => $api.teachers.index({ ...params, ...teachersQuery })"
          :method-view="$api.teachers.get"
          :method-update="$api.teachers.update"
          :method-delete="({ args }) => $api.teachers.delete(...args)"
          :dialog-edit-props="{ 'content-class': 'overflow-y-auto' }"
        )
          template(v-slot:search-fields="{ searchKeys, runSearch }")
            v-text-field(
              v-model="searchKeys['search[name]']"
              label="ФИО"
              rounded
              filled
              @change="runSearch"
            )
          template(
            v-if="serverData"
            v-slot:item.level_id="{ item }"
          )
            span {{ item.level_id | levelOutput(serverData) }}
</template>

<script>
import { mapGetters } from 'vuex';

import { VTextField } from 'vuetify/lib';

import EducationSelect from '@/components/InputFields/teacher/EducationSelect.vue';

export default {
  name: 'TeacherList',
  filters: {
    levelOutput(val, levels) {
      if (!val) return 'Не указано';
      const level = levels.find((i) => i.id === val);
      return level.level_name;
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Логин', value: 'name', component: VTextField, props: { rounded: true, filled: true },
      },
      {
        text: 'Пароль', value: 'password', hiddenForTable: true, component: VTextField, props: { rounded: true, filled: true },
      },
      {
        text: 'Фамилия', value: 'surname', component: VTextField, props: { rounded: true, filled: true },
      },
      {
        text: 'Имя', value: 'first_name', component: VTextField, props: { rounded: true, filled: true },
      },
      {
        text: 'Отчество', value: 'patronymic', component: VTextField, props: { rounded: true, filled: true },
      },
      {
        text: 'Должность', value: 'position', component: VTextField, props: { rounded: true, filled: true },
      },
      {
        text: 'Образование', value: 'level_id', component: EducationSelect,
      },
    ],
  }),
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
    }),
    teachersQuery() {
      const [organization] = this.userData.organizations;
      return {
        'search[organization]': organization && organization.id,
      };
    },
  },
};
</script>
